import MainSchedule from './MainSchedule.view';

export default MainSchedule;
